import { IThirdcode } from "./thirdcode.types";

export class Thirdcode implements IThirdcode {
  readonly id?: number;
  readonly system?: string;
  readonly code?: string;

  constructor(data: IThirdcode) {
    this.id = data.id;
    this.system = data.system;
    this.code = data.code;
  }
}
